export const CHECKBOX_PROPERTIES = {
    HIDE_CAPTION: 'HideCaption'
}